import Vue from 'vue'
import EtaoComponent, {CacheData} from 'etao-component-sp'
import elementUI from 'element-ui'
import Contextmenu from 'vue-contextmenujs'
import vGanttChart from 'v-gantt-chart'
import VueClipboard from 'vue-clipboard2'
import Editor from 'vue2-ace-editor'
import {host, webSocketIp, mesRequests} from '@/api'
import {dic} from '@/utils/i18n'
import {initDefaultValue} from '@/utils/initDefaultValue'

import '@/assets/font/font.css'

export function init () {
    Vue.prototype.$d = dic
    Vue.prototype.$initDefaultValue = initDefaultValue
    Vue.prototype.configHost = host
    Vue.prototype.webSocketIp = webSocketIp
    Vue.config.productionTip = false

    Vue.use(vGanttChart)
    Vue.use(VueClipboard)
    Vue.use(Contextmenu)
    Vue.use(
        EtaoComponent(
            {
                requests: mesRequests
            }
        )
    )
    Vue.use(elementUI)

    Vue.component('editor', Editor)

    // 添加全局指令来阻止表单默认提交
    Vue.directive('prevent-submit', {
        bind (el) {
            el.addEventListener('submit', (e) => {
                e.preventDefault()
            })
        }
    })

    window.CacheData = CacheData
}



// WEBPACK FOOTER //
// ./src/main.base.js